import { render, staticRenderFns } from "./RegisterFree.vue?vue&type=template&id=4dc28c16&lang=pug&"
import script from "./RegisterFree.vue?vue&type=script&lang=js&"
export * from "./RegisterFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports